export default __webpack_public_path__ + "7272063.png";